if (!customElements.get('mobile-sticky-atc')) {
  class MobileStickyAtc extends HTMLElement {
    connectedCallback() {
      this.form = document.getElementById(this.dataset.sourceForm);
      this.sourceButton = this.form?.querySelector('[name="add"]');
      this.button = this.querySelector('[data-sticky-submit]');
      this.productInfo = this.closest('product-info');
      if (!this.form || !this.sourceButton || !this.button) return;

      this.purchaseTarget =
        this.productInfo?.querySelector('variant-selects .product-form__input--size') ||
        this.productInfo?.querySelector('variant-selects') ||
        this.form.closest('product-form') ||
        this.form;

      this.abortController = new AbortController();
      this.syncVisibility = () => {
        const sourcePosition = this.sourceButton.getBoundingClientRect();
        this.hidden = sourcePosition.bottom > 0;
      };
      this.observer = new IntersectionObserver(() => this.syncVisibility(), { threshold: 0.05 });
      this.observer.observe(this.sourceButton);
      window.addEventListener('scroll', this.syncVisibility, {
        passive: true,
        signal: this.abortController.signal,
      });
      window.addEventListener('resize', this.syncVisibility, {
        passive: true,
        signal: this.abortController.signal,
      });

      this.button.addEventListener('click', () => this.scrollToPurchaseControls(), {
        signal: this.abortController.signal,
      });
      this.syncVisibility();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.abortController?.abort();
    }

    scrollToPurchaseControls() {
      const headerStack = document.querySelector('.site-header-stack');
      const headerOffset = headerStack?.getBoundingClientRect().height || 0;
      const targetTop = window.scrollY + this.purchaseTarget.getBoundingClientRect().top - headerOffset - 16;

      window.scrollTo({
        top: Math.max(0, targetTop),
        behavior: 'smooth',
      });
    }
  }

  customElements.define('mobile-sticky-atc', MobileStickyAtc);
}
